import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "modal__radarboard" }
const _hoisted_2 = { class: "modal__radarboard-item" }
const _hoisted_3 = { class: "modal__radarboard-value" }
const _hoisted_4 = { class: "modal__radarboard-item" }
const _hoisted_5 = { class: "modal__radarboard-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_translated_text_component, { translation: "num_of_vehicle15m" }),
        _cache[0] || (_cache[0] = _createTextVNode(": ")),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.lastStatus.num_of_vehicle15m || '-'), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_translated_text_component, { translation: "num_of_vehicle1h" }),
        _cache[1] || (_cache[1] = _createTextVNode(": ")),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.lastStatus.num_of_vehicle1h || '-'), 1)
      ])
    ])
  ]))
}